module.exports = __webpack_public_path__ + "img/icon-07.d89a5259.svg";